import { FIELDS_OF_LAW_ENDPOINT } from 'common/constants'
import { FieldOfLaw } from 'common/graphql/schemaDefinition'
import { request } from 'common/utils'
import { QueryFieldOfLawArgs } from 'packages-mui/advice/interfaces'

import query from '../graphql/getFieldOfLaw.graphql'

export const getFieldOfLaw = (id: string): Promise<{ fieldOfLaw: FieldOfLaw }> =>
  request<{ fieldOfLaw: FieldOfLaw }, QueryFieldOfLawArgs>(FIELDS_OF_LAW_ENDPOINT, query, { id })
